import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  border: 1px solid #b2b2b2;
  border-radius: 8px;
  background: #fdfdfd;
  padding: 1rem 0;
`;
